import axios from 'axios';
import axiosUrl from './axios.service';
import authHeader from '../helpers/auth-header';
import store from '../store/index';
import AuthService from '../services/auth.service';
import router from '../router';
const API_URL = axiosUrl.getAxiosUrl();

class FiltersService {
  getDefaultFilters() {
    return axios
      .get(API_URL + `/FomoRecordFilters/Filters`, {
        headers: authHeader(),
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setOrganisationsFilters',
          response.data.organisationFilters
        );
        store.commit('fomoStatisticsSearch/createOrganisationsOptions');
        store.commit('fomoStatisticsSearch/createOrganisationsOptionsString');
        store.commit(
          'fomoStatisticsSearch/setSubjectsFilters',
          response.data.applicationSubjectFilters
        );
        store.commit('fomoStatisticsSearch/createSubjectsOptions');
        store.commit('fomoStatisticsSearch/createSubjectsOptionsString');
        /*      store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString'); */
        store.commit(
          'fomoStatisticsSearch/setYearsFilters',
          response.data.yearFilters
        );
        store.commit('fomoStatisticsSearch/createYearsOptions');
        store.commit('fomoStatisticsSearch/createYearsOptionsString');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
  /* 
  getCustomersFilter(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/Customers`, {
        headers: authHeader(),
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
 */

  getCustomersWithExcludeFilter(filterText, customerId) {
    return axios
      .get(API_URL + `/FomoRecordFilters/CustomersWithExclude`, {
        headers: authHeader(),
        params: {
          filter: filterText,
          mainCustomerId: customerId != null ? customerId : '',
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  getCustomersFilter(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/Customers`, {
        headers: authHeader(),
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setMainCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createMainCustomersOptions');
        store.commit('fomoStatisticsSearch/createMainCustomersOptionsString');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  getDefaultFileFilters(fileId) {
    return axios
      .get(API_URL + `/FomoRecordFilters/FileFilters`, {
        headers: authHeader(),
        params: {
          fileId: fileId,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setOrganisationsFilters',
          response.data.organisationFilters
        );
        store.commit('fomoStatisticsSearch/createOrganisationsOptions');
        store.commit('fomoStatisticsSearch/createOrganisationsOptionsString');
        store.commit(
          'fomoStatisticsSearch/setSubjectsFilters',
          response.data.applicationSubjectFilters
        );
        store.commit('fomoStatisticsSearch/createSubjectsOptions');
        store.commit('fomoStatisticsSearch/createSubjectsOptionsString');
        store.commit(
          'fomoRecordsSearch/setCustomerFilters',
          response.data.customerFilters
        );
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new FiltersService();
